<div class="overlay basin-width-100 basin-height-100"  >
  <div
    class="p-d-flex p-jc-center p-ai-center basin-width-100 basin-height-100"
  >
    <div class="basin-background-white basin-p-4 rounded overlay-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
